const state = {
  tableHeaderStyle: {
    color: '#212121',
    background: '#F9F9FA',
    boxSizing: 'border-box',
    fontSize: '15px',
    fontFamily: 'Source Han Sans CN Regular',
    borderTop: '1px solid #F3F4F9'
  }
}
export default {
  state
}
